import { useEffect } from "react";
import { advance, useThree } from "@react-three/fiber";
import * as THREE from "three";

// ?film: the launch video's capture script moves the camera and the clock itself, one frame at a time, and gets
// back the picture plus where the points it asked about landed on screen (0..1).
export function Film({ city }) {
  const { gl, camera, scene } = useThree();
  useEffect(() => {
    const [cx, cz] = city.center, at = ([x, y, z]) => new THREE.Vector3(x - cx, y, z - cz);
    window.__film = {
      city,
      frame({ t, pos, look, fov, fog, points = [] }) {
        camera.position.copy(at(pos));
        camera.fov = fov;
        camera.updateProjectionMatrix();
        camera.lookAt(at(look));
        scene.fog = fog ? new THREE.Fog(fog[0], fog[1], fog[2]) : null;
        advance(t);
        const spots = points.map((p) => {
          const v = at(p).project(camera);
          return [(v.x + 1) / 2, (1 - v.y) / 2];
        });
        return { image: gl.domElement.toDataURL("image/jpeg", 0.95), spots };
      },
    };
    return () => { delete window.__film; };
  }, [gl, camera, scene, city]);
  return null;
}
